import type { ResetPageValue } from "../components/dataTable/dataTable.types";

export function hasResetValueChanged(
  previous: ResetPageValue[],
  current: ResetPageValue[],
): boolean {
  return (
    previous.length !== current.length ||
    current.some((value, index) => !Object.is(value, previous[index]))
  );
}
